import "./js/header-hamburger";

const hiddenHeaderLink = document.querySelector(".js-hidden-header-link");

if (hiddenHeaderLink && !sessionStorage.getItem("hide-header-link")) {
    const headerBanner = document.createElement("div");

    headerBanner.classList.add("header__hidden-block", "js-header-hidden-block");
    headerBanner.innerHTML = `
        <a href="${hiddenHeaderLink.dataset.link}" class="header__hidden-link">${hiddenHeaderLink.dataset.text}</a>
        <span class="header__hidden-close js-header-hidden-close"></span>
    `;
    hiddenHeaderLink.parentNode.replaceChild(headerBanner, hiddenHeaderLink);

    const closeBtn = document.querySelector(".js-header-hidden-close");

    if (closeBtn) {
        closeBtn.addEventListener("click", () => {
            const hiddenHeaderBlock = document.querySelector(".js-header-hidden-block");

            if (hiddenHeaderBlock) {
                hiddenHeaderBlock.style.display = "none";
                sessionStorage.setItem("hide-header-link", true);
            }
        });
    }
}
